import React, { useState, useEffect } from "react";
import carregando from "../../assets/loading.gif";
import api from "../../services/api";
import { uploadMaterialFiles, OFFICE_ACCEPT } from "../../utils/uploadMaterialS3";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";
import DataTable from "react-data-table-component";

export default function Edit_Produto({ history }) {
  const [titulo, setTitulo] = useState("");
  const [descr, setDescr] = useState("");
  const [loading, setLoading] = useState("");
  const [itens, setItens] = useState([]);
  const [perguntas, setPerguntas] = useState([]);
  const [pergunta, setPergunta] = useState("");
  const [perguntaId, setPerguntaId] = useState("");
  const [resp1, setResp1] = useState("");
  const [resp2, setResp2] = useState("");
  const [resp3, setResp3] = useState("");
  const [resp4, setResp4] = useState("");
  const [respCorreta, setRespCorreta] = useState("0");
  const [newitem, setNewItem] = useState("");
  const [rowsSel, setRowsSel] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [idempresa, setIdempresa] = useState("");
  const [isIntegracao, setIsIntegracao] = useState(false);
  const [cargaHoraria, setCargaHoraria] = useState("0");
  const [responsavelTecnico, setResponsavelTecnico] = useState("");
  const [corporativo, setCorporativo] = useState(true);
  const [avulso, setAvulso] = useState(false);
  const [valorTreinamento, setValorTreinamento] = useState("");
  const [imgTreinamento, setImgTreinamento] = useState("");
  const [arquivosMaterial, setArquivosMaterial] = useState([]);
  const [uploadingMaterial, setUploadingMaterial] = useState(false);

  const url_string = window.location.href;
  const param = url_string.split("/");
  const isMaster = localStorage.getItem("sgimaster");
  const empresaid = localStorage.getItem("sgiempresaid");
  const reqHeaders = { headers: { "x-tenantid": empresaid, isMaster } };

  const columns = [
    {
      name: 'Ordem',
      selector: row => row.ordem,
      width: '5%'
    },
    {
      name: "Titulo",
      selector: (row) => row.titulo,
      sortable: true,
    },
    {
      name: "Data",
      cell: row => <CustomDate row={row} />,
      sortable: true,
    },
  ];

  const CustomDate = ({ row }) => (
    new Date(row.data).toLocaleDateString('pt-BR')
  )


  const columnsPerguntas = [
    {
      name: "Pergunta",
      selector: (row) => row.pergunta
    },
    {
      name: "Respostas",
      selector: (row) => row.respostas
    },
  ];


  async function loadProd() {
    let data;
    try {
      const response = await api.get(
        "/treinamentos/produto/" + param[4],
        reqHeaders
      );
      data = await response.data;
    } catch (e) {
      if (e.response && e.response.status === 403) {
        alert(
          "Sem permissão para acessar este treinamento (somente treinamentos da sua empresa)."
        );
        history.push("/produtos");
      }
      return false;
    }

    setTitulo(data[0].titulo);
    setDescr(data[0].descr);
    setIdempresa(data[0].idempresa);
    setIsIntegracao(data[0].isIntegracao);
    setCargaHoraria(data[0].cargaHoraria);
    setResponsavelTecnico(data[0].responsavelTecnico);
    setCorporativo(data[0].corporativo !== undefined ? data[0].corporativo : !data[0].avulso);
    setAvulso(data[0].avulso === true);
    setValorTreinamento(data[0].valor !== undefined && data[0].valor !== null ? String(data[0].valor) : (data[0].valorTreinamento !== undefined && data[0].valorTreinamento !== null ? String(data[0].valorTreinamento) : ""));
    setImgTreinamento(data[0].img != null ? String(data[0].img) : "");
    setArquivosMaterial(
      Array.isArray(data[0].arquivosMaterial) ? data[0].arquivosMaterial : []
    );

    if(data[0].isIntegracao){
      setTimeout(() => {
        if (document.getElementById("menu_integracao")) {
          document.getElementById("menu_integracao").className = "active";
        }
      }, 50);
    } else {
      setTimeout(() => {
        if (document.getElementById("menu_produto")) {
          document.getElementById("menu_produto").className = "active";
        }
      }, 50);
    }
    return true;
  }

  async function loadCompItens() {
    const query = "/treinamentos/topico/produto/" + param[4];
    const response = await api.get(query, reqHeaders);
    const data = await response.data;
    setItens(data);
  }

  async function loadPerguntas() {
    const query = "/treinamentos/avaliacao/produto/" + param[4];
    const response = await api.get(query, reqHeaders);
    const data = await response.data;
    setPerguntas(data);
  }

  async function loadEmpresas() {
    const query = "/treinamentos/empresa";
    const response = await api.get(query, reqHeaders);
    const data = await response.data;
    setEmpresas(data);
  }

  const handleChange = (state) => {
    setRowsSel(state.selectedRows);
  };

  async function handleMaterialFileChange(event) {
    const input = event.target;
    const files = input.files;
    if (!files || files.length === 0) return;
    setUploadingMaterial(true);
    try {
      const novos = await uploadMaterialFiles(Array.from(files));
      setArquivosMaterial((prev) => [...prev, ...novos]);
    } catch (e) {
      alert(e.message || "Erro ao enviar arquivo.");
    }
    input.value = "";
    setUploadingMaterial(false);
  }

  function removeMaterialIndex(idx) {
    setArquivosMaterial((prev) => prev.filter((_, i) => i !== idx));
  }

  async function handleSubmit(event) {
    setLoading(true);
    event.preventDefault();

    if (!corporativo && !avulso) {
      alert("Marque pelo menos um tipo: Corporativo ou Avulso.");
      setLoading(false);
      return;
    }

    const dataobj = {
      titulo,
      descr,
      cargaHoraria,
      responsavelTecnico,
      idempresa,
      corporativo: corporativo ? 1 : 0,
      avulso: avulso ? 1 : 0,
      valor: avulso ? parseFloat(valorTreinamento) || 0 : null,
      img: imgTreinamento.trim() || null,
      arquivosMaterial,
    };

    await api.put("/treinamentos/produto/" + param[4], dataobj, reqHeaders);
    setLoading(false);
    if(isIntegracao){
      history.push("/integracoes");
    } else {
      history.push("/produtos");
    }
    
  }

  async function handleRemove(id, item) {
    if (rowsSel.length > 0) {
      if (window.confirm("Confirma remoção dos itens selecionados ?")) {
        setLoading(true);
        rowsSel.map(async (item) => {
          await api
            .delete("/treinamentos/topico/" + item._id, reqHeaders)
            .then((res) => {
              if (res.data.error != undefined) {
                alert(res.data.error);
                setLoading(false);
                return;
              } else {
                loadCompItens();
                setLoading(false);
              }
            })
            .catch((error) => {
              alert(error);
              setLoading(false);
              return;
            });
        });
      }
    } else {
      alert("Nenhum registro selecionado !");
    }
  }

  async function handleRemovePergunta(id) {
      if (window.confirm("Confirma remoção dos itens selecionados ?")) {
        setLoading(true);

          await api
            .delete("/treinamentos/avaliacao/" + id, reqHeaders)
            .then((res) => {
              if (res.data.error != undefined) {
                alert(res.data.error);
                setLoading(false);
                return;
              } else {
                loadPerguntas();
                setLoading(false);
              }
            })
            .catch((error) => {
              alert(error);
              setLoading(false);
              return;
            });

      }
  }

  async function addNewItem() {
    setLoading(true);

    const dataobj = {
      titulo: newitem,
      descrHtml: "<span>Descreva a ação aqui</span>",
      data: new Date(),
      idproduto: param[4],
    };

    await api.post("/treinamentos/topico", dataobj, reqHeaders);
    loadCompItens();
    setLoading(false);
  }

  async function addNewItemPergunta() {
    setLoading(true);
    const arrRespostas = []
    arrRespostas.push(resp1)
    arrRespostas.push(resp2)
    arrRespostas.push(resp3)
    arrRespostas.push(resp4)

    const dataobj = {
      pergunta: pergunta,
      respostas: arrRespostas,
      respCorreta: respCorreta,
      idproduto: param[4],
    };

    if(perguntaId == ""){
      await api.post("/treinamentos/avaliacao", dataobj, reqHeaders);
    } else {
      await api.put("/treinamentos/avaliacao/"+perguntaId, dataobj, reqHeaders);
    }
      loadPerguntas();
      setPergunta("");
      setResp1("");
      setResp2("");
      setResp3("");
      setResp4("");
      setRespCorreta("0");
      setPerguntaId("");
      setLoading(false);
  }

  const carregaPergunta = async (state) => {
    setLoading(true);
    const query = "/treinamentos/avaliacao/" + state;
    const response = await api.get(query, reqHeaders);
    const data = await response.data;
    console.log(JSON.stringify(data));
    setPerguntaId(data[0]._id);
    setPergunta(data[0].pergunta);
    setResp1(data[0].respostas[0]);
    setResp2(data[0].respostas[1]);
    setResp3(data[0].respostas[2]);
    setResp4(data[0].respostas[3]);
    setRespCorreta(data[0].respCorreta);
    
    setLoading(false);
  }

  const goToPage = (state) => {
    history.push("/topico/" + state._id);
  };

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    (async () => {
      const ok = await loadProd();
      if (cancelled || !ok) {
        setLoading(false);
        return;
      }
      await loadCompItens();
      if (cancelled) return;
      await loadPerguntas();
      if (cancelled) return;
      await loadEmpresas();
      if (!cancelled) setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <Header />
      <SideMenu />

      <div className="content-wrapper">
        <section className="content-header">
          <h1>{titulo}</h1>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box-footer">
                <button
                  className="btn btn-default"
                  style={{ marginRight: 8 }}
                  onClick={() => isIntegracao ? history.push("/integracoes") : history.push("/produtos")}
                >
                  Voltar
                </button>

                <button
                  type="submit"
                  form="formCheck"
                  className="btn btn-success"
                  style={{ marginRight: 8 }}
                >
                  Salvar
                </button>
              </div>
              <div className="box box-primary">
                {loading && (
                  <div style={{ alignItems: "center", textAlign: "center" }}>
                    <img src={carregando} width="80"></img>
                  </div>
                )}
                <form
                  className="form-horizontal"
                  id="formCheck"
                  onSubmit={handleSubmit}
                >
                  <div className="box-body">
                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="status">
                        Titulo*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="nome"
                          placeholder="Nome do Produto"
                          className="form-control"
                          value={titulo}
                          required
                          onChange={(event) => setTitulo(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="status">
                        Conteúdo*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="nome"
                          placeholder="Conteúdo do Treinamento"
                          className="form-control"
                          value={descr}
                          required
                          onChange={(event) => setDescr(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="status">
                        Carga Horária*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="nome"
                          placeholder="Carga Horária do treinamento"
                          className="form-control"
                          value={cargaHoraria}
                          required
                          onChange={(event) => setCargaHoraria(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="nome">
                        Responsável Técnico
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="responsavelTec"
                          placeholder="Responsável Técnico Caso NR"
                          className="form-control"
                          value={responsavelTecnico}
                          onChange={(event) => setResponsavelTecnico(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2">Tipo de Treinamento*</label>
                      <div className="col-sm-10">
                        <div className="checkbox">
                          <label>
                            <input
                              type="checkbox"
                              checked={corporativo}
                              onChange={(e) => setCorporativo(e.target.checked)}
                            />
                            {' '}Corporativo
                          </label>
                        </div>
                        <div className="checkbox">
                          <label>
                            <input
                              type="checkbox"
                              checked={avulso}
                              onChange={(e) => {
                                setAvulso(e.target.checked);
                                if (!e.target.checked) setValorTreinamento("");
                              }}
                            />
                            {' '}Avulso
                          </label>
                        </div>
                        <small className="text-muted">Marque um ou ambos. Pelo menos um deve estar marcado.</small>
                      </div>
                    </div>

                    {avulso && (
                      <div className="form-group">
                        <label className="col-sm-2" htmlFor="valorTreinamento">
                          Valor (R$)*
                        </label>
                        <div className="col-sm-10">
                          <input
                            id="valorTreinamento"
                            type="number"
                            step="0.01"
                            min="0"
                            placeholder="0.00"
                            className="form-control"
                            value={valorTreinamento}
                            required
                            onChange={(event) => setValorTreinamento(event.target.value)}
                          />
                        </div>
                      </div>
                    )}

                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="imgTreinamento">
                        Imagem (URL)
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="imgTreinamento"
                          type="url"
                          placeholder="https://exemplo.com/imagem.jpg"
                          className="form-control"
                          value={imgTreinamento}
                          onChange={(e) => setImgTreinamento(e.target.value)}
                        />
                        <small className="text-muted">URL da imagem exibida na página Treinamentos Abertos do site.</small>
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2" htmlFor="materialOfficeEdit">
                        Material de Apoio
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="materialOfficeEdit"
                          type="file"
                          className="form-control"
                          accept={OFFICE_ACCEPT}
                          multiple
                          disabled={uploadingMaterial}
                          onChange={handleMaterialFileChange}
                        />
                        {uploadingMaterial && (
                          <div style={{ marginTop: 8 }}>
                            <img src={carregando} width="40" alt="enviando" />
                            <span className="text-muted" style={{ marginLeft: 8 }}>
                              Enviando…
                            </span>
                          </div>
                        )}
                        <small className="text-muted">
                          Upload automático via servidor para o S3. Word, Excel, PowerPoint, etc.
                        </small>
                        {arquivosMaterial.length > 0 && (
                          <ul className="list-unstyled" style={{ marginTop: 10 }}>
                            {arquivosMaterial.map((a, idx) => (
                              <li key={idx} style={{ marginBottom: 6 }}>
                                <a
                                  href={a.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {a.nome || "arquivo"}
                                </a>
                                {" "}
                                <button
                                  type="button"
                                  className="btn btn-xs btn-danger"
                                  onClick={() => removeMaterialIndex(idx)}
                                >
                                  remover
                                </button>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>

                    <div className="form-group">
                    <label className="col-sm-2" htmlFor="status">
                        Empresa*
                      </label>
                      <div className="col-sm-10">
                      <select
                        id="idcompressor"
                        value={idempresa}
                        placeholder="Empresa do usuário"
                        className="form-control select2"
                        disabled={isMaster == "false"}
                        onChange={(event) => setIdempresa(event.target.value)}
                      >
                        <option key="" value="" disabled>
                          -- Selecione --
                        </option>
                        {empresas.map((empresa) => (
                          <option key={empresa._id} value={empresa._id}>
                            {empresa.nome}
                          </option>
                        ))}
                        <option key={"ALL"} value={"ALL"}>
                            {"Todas"}
                          </option>
                      </select>
                    </div>
                    </div>

                    <div className="nav-tabs-custom">
                      <ul className="nav nav-tabs">
                        <li className="active">
                          <a
                            href="#tab_1"
                            data-toggle="tab"
                            aria-expanded="false"
                          >
                            Etapas
                          </a>
                        </li>
                        <li>
                          <a
                            href="#tab_2"
                            data-toggle="tab"
                            aria-expanded="false"
                          >
                            Avaliação
                          </a>
                        </li>
                        
                      </ul>

                      <div className="tab-content">
                        <div className="tab-pane active" id="tab_1">
                          <div className="row">
                            
                              
                                {/* /.box-header */}
                                <div className="box-body">
                                  <div className="row">
                                    <div className="col-xs-12">
                                      <a
                                        className="btn btn-app"
                                        data-toggle="modal"
                                        data-target="#modal-newitem"
                                      >
                                        <i className="fa fa-plus"></i> Adicionar
                                        Tópico
                                      </a>

                                      <a
                                        className="btn btn-app"
                                        onClick={() => {
                                          handleRemove("", "");
                                        }}
                                      >
                                        <i className="fa fa-remove"></i> Remover
                                        Selecionado
                                      </a>
                                      <div className="box">
                                        {/* /.box-header */}
                                        <DataTable
                                          columns={columns}
                                          data={itens}
                                          onRowClicked={goToPage}
                                          selectableRows
                                          pointerOnHover
                                          highlightOnHover
                                          onSelectedRowsChange={handleChange}
                                          noDataComponent={""}
                                        />

                                        
                                        {/* /.box-body */}
                                      </div>
                                      {/* /.box */}
                                    </div>
                                  </div>
                                </div>

                                <p>&nbsp;</p>
                                {/* /.box-body */}
                              
                              {/* /.box */}
                            
                          </div>
                        </div>
                        <div className="tab-pane" id="tab_2">
                          <div className="row">
                            
                              
                                {/* /.box-header */}
                                <div className="box-body">
                                  <div className="row">
                                    <div className="col-xs-12">
                                      <a
                                        id="modalPerguntaAction"
                                        className="btn btn-app"
                                        data-toggle="modal"
                                        data-target="#modal-pergunta_newitem"
                                      >
                                        <i className="fa fa-plus"></i> Adicionar
                                        Pergunta
                                      </a>

                                      
                                      <div className="box">
                                      <table className="table table-hover">
                                    <tbody>
                                      <tr>
                                        <th>#</th>
                                        <th>Pergunta</th>
                                        <th>Respostas</th>
                                      </tr>

                                      {perguntas &&
                                        perguntas.map((item, index) => (
                                          <tr>
                                            <td>{index+1}</td>
                                            <td>{item.pergunta}</td>
                                            <td>{item.respostas}</td>
                                            <td><a href="#" onClick={() => carregaPergunta(item._id)} data-toggle="modal" data-target="#modal-pergunta_newitem">Editar</a></td>
                                            <td><a href="#" onClick={() => handleRemovePergunta(item._id)}>Remover</a></td>
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                      </div>
                                      {/* /.box */}
                                    </div>
                                  </div>
                                </div>

                                <p>&nbsp;</p>
                                {/* /.box-body */}
                              
                              {/* /.box */}
                            
                          </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>

                  {/* <div className="box-footer">
                  <button
                      className="btn btn-default"
                      style={{marginRight:8}}
                      onClick={() => history.push("/produtos")}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-info">
                      Salvar
                    </button>
                  </div> */}
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div
        className="modal fade"
        id="modal-newitem"
        style={{ display: "none" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title">Adicionar Novo Topico</h4>
            </div>
            <div className="modal-body">
              <input
                id="itemdesc"
                placeholder="Nome do Topico"
                className="form-control"
                required
                maxLength={200}
                value={newitem}
                onChange={(event) => setNewItem(event.target.value)}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default pull-left"
                data-dismiss="modal"
              >
                Voltar
              </button>
              <button
                type="button"
                onClick={() => addNewItem()}
                data-dismiss="modal"
                className="btn btn-primary"
              >
                Adicionar
              </button>
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>

      <div
        className="modal fade"
        id="modal-pergunta_newitem"
        style={{ display: "none" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title">Adicionar Nova Avaliação</h4>
            </div>
            <div className="modal-body">
            <label>Pergunta</label>
              <input
                id="pergunta"
                placeholder="Insira a pergunta que será feita ao colaborador"
                className="form-control"
                required
                maxLength={500}
                value={pergunta}
                onChange={(event) => setPergunta(event.target.value)}
              />
              <br></br>
              <label>Resposta 1</label>
              <input
                id="resposta"
                placeholder="Insira a resposta 1"
                className="form-control"
                required
                maxLength={500}
                value={resp1}
                onChange={(event) => setResp1(event.target.value)}
              />
              <br></br>
              <label>Resposta 2</label>
              <input
                id="resposta"
                placeholder="Insira a resposta 2"
                className="form-control"
                required
                maxLength={500}
                value={resp2}
                onChange={(event) => setResp2(event.target.value)}
              />
              <br></br>
              <label>Resposta 3</label>
              <input
                id="resposta"
                placeholder="Insira a resposta 3"
                className="form-control"
                required
                maxLength={500}
                value={resp3}
                onChange={(event) => setResp3(event.target.value)}
              />
              <br></br>
              <label>Resposta 4</label>
              <input
                id="resposta"
                placeholder="Insira a resposta 4"
                className="form-control"
                required
                maxLength={500}
                value={resp4}
                onChange={(event) => setResp4(event.target.value)}
              />
              <br></br>
              <label>Qual é a resposta correta ?</label>
              <select
                id="idRespostaCorreta"
                value={respCorreta}
                className="form-control select2"
                required
                onChange={(event) => setRespCorreta(event.target.value)}
              >
                <option key="0" value="0">
                  1
                </option>
                <option key="1" value="1">
                  2
                </option>
                <option key="2" value="2">
                  3
                </option>
                <option key="3" value="3">
                  4
                </option>
              </select>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default pull-left"
                data-dismiss="modal"
              >
                Voltar
              </button>
              <button
                type="button"
                onClick={() => addNewItemPergunta()}
                data-dismiss="modal"
                className="btn btn-primary"
              >
                Salvar
              </button>
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>

      <Footer />
    </>
  );
}
